import {store} from '../store'

export default (to, from, next) => {
  if (store.getters.user) {
    next()
  } else {
  	// store.commit('setSnack', 'Please Sign In')
  	// store.commit('signInDialog', true)
    next('/')
  }
}
